const useFully = () => {
  return window.fully
}

export default useFully
